import React, { useState } from 'react';
import { FiMail, FiClock, FiSend, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import toast from 'react-hot-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [expandedFAQs, setExpandedFAQs] = useState(new Set());
  const [allExpanded, setAllExpanded] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('/api/contacts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || '문의 전송에 실패했습니다');
      }

      await response.json();
      
      toast.success('문의가 성공적으로 전송되었습니다. 빠른 시일 내에 답변드리겠습니다.');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Contact submission error:', error);
      toast.error(error.message || '문의 전송 중 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  const toggleFAQ = (index) => {
    const newExpandedFAQs = new Set(expandedFAQs);
    if (newExpandedFAQs.has(index)) {
      newExpandedFAQs.delete(index);
    } else {
      newExpandedFAQs.add(index);
    }
    setExpandedFAQs(newExpandedFAQs);
  };

  const toggleAllFAQs = () => {
    if (allExpanded) {
      setExpandedFAQs(new Set());
      setAllExpanded(false);
    } else {
      setExpandedFAQs(new Set(faqs.map((_, index) => index)));
      setAllExpanded(true);
    }
  };

  const contactInfo = [
    {
      icon: FiMail,
      title: '이메일',
      content: 'contact@englishpt.com',
      link: 'mailto:contact@englishpt.com'
    },
    // {
    //   icon: FiPhone,
    //   title: '전화번호',
    //   content: '02-1234-5678',
    //   link: 'tel:02-1234-5678'
    // },
    // {
    //   icon: FiMapPin,
    //   title: '주소',
    //   content: '서울시 강남구 테헤란로 123, 4층',
    //   link: null
    // },
    {
      icon: FiClock,
      title: '운영시간',
      content: '평일 09:00 - 18:00',
      link: null
    }
  ];

  const faqs = [
    {
      question: '회원가입은 무료인가요?',
      answer: '네, EnglishPT의 기본 회원가입은 완전히 무료입니다. 프리미엄 강의나 추가 서비스에 대해서만 요금이 발생합니다.'
    },
    {
      question: '강의를 언제든지 들을 수 있나요?',
      answer: '네, 등록한 강의는 언제든지 반복해서 들을 수 있습니다. 학습 진행 상황도 자동으로 저장됩니다.'
    },
    {
      question: '환불 정책은 어떻게 되나요?',
      answer: '강의 구매 후 30일 이내에는 100% 환불이 가능합니다. 단, 강의 진행률이 50%를 초과한 경우 환불이 제한될 수 있습니다.'
    },
    {
      question: '강사가 되려면 어떻게 해야 하나요?',
      answer: '강사 지원은 "강사 지원하기" 페이지에서 신청하실 수 있습니다. 자격 검토 후 연락드리겠습니다.'
    },
    {
      question: '모바일에서도 강의를 들을 수 있나요?',
      answer: '네, EnglishPT는 모든 디바이스에서 최적화되어 있습니다. 스마트폰, 태블릿, 컴퓨터 어디서든 편리하게 학습하실 수 있습니다.'
    },
    {
      question: '강의 수료증은 발급되나요?',
      answer: '네, 강의 완료 시 수료증을 발급해드립니다. 수료증은 PDF 형태로 다운로드 가능하며, 이력서나 포트폴리오에 활용하실 수 있습니다.'
    },
    {
      question: '학습 진도는 어떻게 확인하나요?',
      answer: '대시보드에서 각 강의별 학습 진도를 실시간으로 확인할 수 있습니다. 완료된 강의, 진행 중인 강의, 남은 강의를 한눈에 볼 수 있습니다.'
    },
    {
      question: '질문이나 피드백은 어떻게 남기나요?',
      answer: '각 강의 페이지의 댓글 기능을 통해 질문을 남기실 수 있으며, 강사가 직접 답변해드립니다. 또한 이 페이지의 문의 양식을 통해 언제든지 연락주실 수 있습니다.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-subtle py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            문의하기
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            궁금한 점이 있으시거나 도움이 필요하시면 언제든지 연락주세요. 
            빠른 시일 내에 답변드리겠습니다.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-soft p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">문의 양식</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    이름 *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    placeholder="이름을 입력하세요"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    이메일 *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    placeholder="이메일을 입력하세요"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                  제목 *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  placeholder="문의 제목을 입력하세요"
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  메시지 *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  placeholder="문의 내용을 자세히 입력하세요"
                ></textarea>
              </div>
              
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-primary-800 text-white py-3 px-6 rounded-lg font-medium hover:bg-primary-700 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
              >
                {loading ? (
                  <>
                    <div className="loading-spinner h-5 w-5"></div>
                    <span>전송 중...</span>
                  </>
                ) : (
                  <>
                    <FiSend className="h-5 w-5" />
                    <span>문의 보내기</span>
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            {/* Contact Info */}
            <div className="bg-white rounded-lg shadow-soft p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">연락처 정보</h2>
              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <info.icon className="h-6 w-6 text-primary-800" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-medium text-gray-900">{info.title}</h3>
                      {info.link ? (
                        <a
                          href={info.link}
                          className="text-gray-600 hover:text-primary-800 transition-colors duration-200"
                        >
                          {info.content}
                        </a>
                      ) : (
                        <p className="text-gray-600">{info.content}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Office Hours */}
            <div className="bg-white rounded-lg shadow-soft p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">운영시간</h2>
              <div className="space-y-4">
                <div className="flex justify-between">
                  <span className="text-gray-600">평일</span>
                  <span className="font-medium">09:00 - 18:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">토요일</span>
                  <span className="font-medium">10:00 - 15:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">일요일</span>
                  <span className="font-medium">휴무</span>
                </div>
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-sm text-gray-500">
                    * 공휴일 및 주말에는 답변이 지연될 수 있습니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">자주 묻는 질문</h2>
            <p className="text-lg text-gray-600">
              고객님들이 자주 문의하시는 내용들을 정리했습니다.
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-soft overflow-hidden">
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">질문 목록</h3>
                <button
                  onClick={toggleAllFAQs}
                  className="text-sm text-primary-800 hover:text-primary-700 transition-colors duration-200 font-medium"
                >
                  {allExpanded ? '모두 닫기' : '모두 열기'}
                </button>
              </div>
              
              {faqs.map((faq, index) => (
                <div key={index} className="border-b border-gray-200 last:border-b-0">
                  <div 
                    className="flex justify-between items-center p-6 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h3 className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                    <div className="flex-shrink-0">
                      {expandedFAQs.has(index) ? (
                        <FiChevronUp className="h-5 w-5 text-primary-800" />
                      ) : (
                        <FiChevronDown className="h-5 w-5 text-primary-800" />
                      )}
                    </div>
                  </div>
                  {expandedFAQs.has(index) && (
                    <div className="px-6 pb-6">
                      <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Map Section */}
        {/* <div className="mt-16 bg-white rounded-lg shadow-soft p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">오시는 길</h2>
          <div className="bg-gray-200 rounded-lg h-64 flex items-center justify-center">
            <p className="text-gray-600">지도가 여기에 표시됩니다</p>
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <p>📍 서울시 강남구 테헤란로 123, 4층</p>
            <p>🚇 지하철: 2호선 강남역 3번 출구에서 도보 5분</p>
            <p>🚌 버스: 강남역 정류장 하차</p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Contact; 